import React, { useEffect, useState } from "react";
import './Botoesmobile.css';
import { useMediaQuery } from 'react-responsive';

import { getIluminacao } from "../../../API/getIluminação";
import { sendCommandFlex35 } from "../../../API/AcionamentoFlex35";
import { getLuzesStatusFlex35 } from "../../../API/FeedBackLuzes";

function BotoesMobile() {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [buttonsData, setButtonsData] = useState([]);
  const [imageStates, setImageStates] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Obtém os dados de iluminação
        const iluminacaoData = await getIluminacao();

        // Obtém o status das luzes
        const luzesStatus = await getLuzesStatusFlex35();

        // Ordena os dados pelo número do botão
        const sortedData = iluminacaoData.sort((a, b) => a.id - b.id);

        // Mapeia o estado inicial com base no status das luzes
        const initialStates = sortedData.reduce((acc, item) => {
          const isLightOn = luzesStatus.includes(item.oncommand);
          acc[item.groupid] = isLightOn;
          return acc;
        }, {});
        setButtonsData(sortedData);
        setImageStates(initialStates);
      } catch (error) {
        console.error("Erro ao carregar os dados:", error);
      }
    };

    fetchData();

    const intervalId = setInterval(fetchData, 8000);

    return () => clearInterval(intervalId);
  }, []);

  const handleToggleLightGroup = (groupId, newImageState, onCommand, offCommand) => {
    const command = newImageState ? onCommand : offCommand;

    // Evita enviar comando vazio (grupo sem oncommand/offcommand cadastrado).
    // Sem isso, o back recebe { buttonId, action: undefined } e o botão alterna à toa.
    if (!command) {
      console.warn(`Grupo ${groupId} sem comando on/off — clique ignorado.`);
      return;
    }

    setImageStates(prevState => ({ ...prevState, [groupId]: newImageState }));
    sendCommandFlex35(groupId, command);
  };

  if (!isMobile) {
    return null; // Não renderiza o componente em telas maiores
  }

  return (
    <div id="BotoesMobile">
      <h2 id='Title-botoes-Mobile'>Térreo</h2>
      <div className="campoBotoesAcionamento-mobile">
        {buttonsData.map(button => (
          <div
            key={button.id}
            className="clickable-element-mobile"
            onClick={() => 
              handleToggleLightGroup(
                button.groupid,
                !imageStates[button.groupid],
                button.oncommand,
                button.offcommand
              )
            }
          >
            <p className={`NumberTextBar-mobile${imageStates[button.groupid] ? 'Highlighted-mobile' : ''}`}>
              {button.id.toString().padStart(2, '0')}
            </p>
            <p className="textBar-mobile">{button.descricao}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BotoesMobile;
